import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiListParams, ApiListResponse } from '@core/api/api.model';
import { ITag, ITagApi, ITagCreateRequest } from './tag.model';

@Injectable({ providedIn: 'root' })
export class TagApi {
  private readonly http = inject(HttpClient);

  getTags(params: ApiListParams): Observable<ApiListResponse<ITagApi>> {
    return this.http.get<ApiListResponse<ITagApi>>(`${environment.api}tags/`, {
      params: params as Record<string, string | number | boolean>,
    });
  }

  createTag(input: ITagCreateRequest): Observable<ITagApi> {
    return this.http.post<ITagApi>(`${environment.api}tags/`, input);
  }

  /** Preferred update — only the editable `name` field is sent. */
  patchTag(id: number, name: string): Observable<ITagApi> {
    return this.http.patch<ITagApi>(`${environment.api}tags/${id}/`, { name });
  }

  /** Fallback update when the API rejects a partial PATCH — sends the whole tag. */
  putTag(tag: ITag): Observable<ITagApi> {
    return this.http.put<ITagApi>(`${environment.api}tags/${tag.id}/`, tag);
  }

  deleteTag(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.api}tags/${id}/`);
  }
}
